import { useCallback, useMemo, useState } from 'react';

import { mockNotifications } from '@/features/notifications/mocks/notifications.mock';
import type { Notification } from '@/features/notifications/types/Notifications.types';

// TODO: Integrate with actual notifications API when available
export const useNotifications = () => {
  const [notifications, setNotifications] = useState<Notification[]>(mockNotifications);

  const hasUnreadNotifications = useMemo(() => {
    return notifications.some((notification) => !notification.isRead);
  }, [notifications]);

  const unreadCount = useMemo(() => {
    return notifications.filter((notification) => !notification.isRead).length;
  }, [notifications]);

  const markAsRead = useCallback((id: string) => {
    setNotifications((prev) =>
      prev.map((notification) => (notification.id === id ? { ...notification, isRead: true } : notification))
    );
  }, []);

  const markAllAsRead = useCallback(() => {
    setNotifications((prev) => prev.map((notification) => ({ ...notification, isRead: true })));
  }, []);

  return {
    notifications,
    hasUnreadNotifications,
    unreadCount,
    markAsRead,
    markAllAsRead
  };
};
